import { ContentItemViewNodesType } from '../../../types'

/**
 * Generic sorting function for ContentItemViewNodesType nodes
 * @param nodes - Array of nodes to sort
 * @param key - The property to sort by
 * @param ascending - Sort direction (default: ascending)
 * @returns Sorted array of nodes (new array)
 */
export const sortNodes = <T extends Partial<ContentItemViewNodesType>>(
    nodes: T[],
    key: keyof ContentItemViewNodesType,
    ascending = true
): T[] => {
    return [...nodes].sort((a, b) => {
        const aValue = a[key] ?? 0
        const bValue = b[key] ?? 0
        
        if (typeof aValue === 'number' && typeof bValue === 'number') {
            return ascending ? aValue - bValue : bValue - aValue
        }
        
        const result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0
        return ascending ? result : -result
    })
}